module.exports = __webpack_public_path__ + "media/npc_dota_hero_skywrath_mage.9e844e16.webm";